import { createSlice, createAsyncThunk  } from '@reduxjs/toolkit'
import { nanoid } from '@reduxjs/toolkit'
import axios from 'axios'
import authService from '../../api-authorization/AuthorizeService'

const initialState = {
    events: [],
    status: 'idle',
    error: null
}

export const fetchEvents = createAsyncThunk(
    'events/fetchEvents',
    async () => {
        const myToken = await authService.getAccessToken();
        const AuthStr = 'Bearer ' + myToken;
        const res = await axios.get('/api/Events', { 'headers': { 'Authorization': AuthStr } }); // Return a promise
        return res.data;
    }
);

export const addNewEvent = createAsyncThunk(
    'events/addNewEvent',
    // The payload creator receives the partial `{title, content, user}` object
    async initialEvent => {
        // We send the initial data to the fake API server
        //const response = await client.event('/fakeApi/events', initialEvent)
        // The response includes the complete event object, including unique ID
        //return response.data
        const myToken = await authService.getAccessToken();

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + myToken,
                /*'My-Custom-Header': 'foobar'*/
            },
            body: JSON.stringify(initialEvent)
        };
        //fetch('/api/Events', requestOptions)
        //    .then((response) => { return response.data })
        //    //.then(data => this.setState({ postId: data.id }));
        //const res = await fetch('/api/Events/', requestOptions);
        //return res.formData;

        //const res = await axios.get('/api/Events'); // Return a promise
        //return res.data;

        var headers = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${myToken}`
            }
        }
        //https://forum.strapi.io/t/solved-new-version-axios-post-request-responces-400-bad-request/16081
        //https://stackoverflow.com/questions/72307388/axioserror-request-failed-with-status-code-400-in-react-js
        //400 error - bad reqeust - caused by missing or invalid field
        try {
            const data = JSON.stringify(initialEvent)
            //const res = await axios.post('/api/Events/', data, headers);
            const res = await axios.post('/api/Events/', data, headers);
            return res.data;
        } catch (e) {
            console.log(e);
            alert(e.response.data.title);
            //e.response.data.errors.forEach(error => alert(error));
        }

    }
)

export const updateEvent = createAsyncThunk(
    'events/updateEvent',
    // The payload creator receives the partial `{title, content, user}` object
    async initialEvent => {
        // We send the initial data to the fake API server
        //const response = await client.event('/fakeApi/events', initialEvent)
        // The response includes the complete event object, including unique ID
        //return response.data
        const myToken = await authService.getAccessToken();
        const data = JSON.stringify(initialEvent)
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + myToken,
                /*'My-Custom-Header': 'foobar'*/
            },
            body: JSON.stringify(initialEvent)
        };
        const res = await fetch('/api/Events/' + initialEvent.eventId, requestOptions);
        //fetch('/api/Events/' + initialEvent.eventId, requestOptions).then((response) => { return response })
        //.then(data => this.setState({ postId: data.id }));

        //const article = { title: 'React Put Request Example' };
        //const response = await axios.put('/api/Events/' + initialEvent.eventId, requestOptions);

        //try {
        //    const data = JSON.stringify(initialEvent)
        //    //const res = await axios.post('/api/Events/', data, headers);
        //    const res = await axios.post('/api/Events/', data, headers);
        //    return res.data;
        //} catch (e) {
        //    console.log(e);
        //    alert(e.response.data.title);
        //    //e.response.data.errors.forEach(error => alert(error));
        //}


        return initialEvent;
    }
)

export const deleteEvent = createAsyncThunk(
    'events/deleteEvent',
    // The payload creator receives the partial `{title, content, user}` object
    async initialEvent => {
        // We send the initial data to the fake API server
        //const response = await client.event('/fakeApi/events', initialEvent)
        // The response includes the complete event object, including unique ID
        //return response.data
        const myToken = await authService.getAccessToken();

        const requestOptions = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + myToken,
                /*'My-Custom-Header': 'foobar'*/
            },
            body: JSON.stringify(initialEvent)
        };
        const res = await fetch('/api/Events/' + initialEvent.eventId, requestOptions);
        //fetch('/api/Events/' + initialEvent.eventId, requestOptions).then((response) => { return response })
        //.then(data => this.setState({ postId: data.id }));

        //const article = { title: 'React Put Request Example' };
        //const response = await axios.put('/api/Events/' + initialEvent.eventId, requestOptions);

        return initialEvent;
    }
)

export const cloneEvent = createAsyncThunk(
    'events/cloneEvent',
    // The payload creator receives the partial `{title, content, user}` object
    async initialEvent => {
        // The response includes the complete event object, including unique ID
        //return response.data
        const myToken = await authService.getAccessToken();

        ////following - not needed anymore
        //const data = JSON.stringify(initialEvent)
        //const requestOptions = {
        //    method: 'POST',
        //    headers: {
        //        'Content-Type': 'application/json',
        //        'Authorization': 'Bearer ' + myToken,
        //        /*'My-Custom-Header': 'foobar'*/
        //    },
        //    body: JSON.stringify(initialEvent)
        //};
        //const res = await fetch('/api/Events/Clone/' + initialEvent.eventId, requestOptions);
        ////fetch('/api/Events/' + initialEvent.eventId, requestOptions).then((response) => { return response })
        //.then(data => this.setState({ postId: data.id }));

        //const article = { title: 'React Put Request Example' };
        //const response = await axios.put('/api/Events/' + initialEvent.eventId, requestOptions);

        //new
        const formData = new FormData();
        formData.append("eventName", initialEvent.eventName);
        formData.append("eventStartDateTime", initialEvent.eventStartDateTime);
        formData.append("copyEventDelegations", initialEvent.copyEventDelegations);
        formData.append("copyDicsountPolicies", initialEvent.copyDicsountPolicies);


        //try {
        //    const data = JSON.stringify(initialEvent)
        //    //const res = await axios.post('/api/Events/', data, headers);
        //    const res = await axios.post('/api/Events/', data, headers);
        //    return res.data;
        //} catch (e) {
        //    console.log(e);
        //    alert(e.response.data.title);
        //    //e.response.data.errors.forEach(error => alert(error));
        //}

        var headers = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${myToken}`
            }
        }

        try {
            //const rest = await axios({
            //    method: "post",
            //    url: '/api/Events/Clone/' + initialEvent.eventId,
            //    data: formData,
            //    headers: { "Content-Type": "multipart/form-data", 'Authorization': `Bearer ${myToken}` },
            //})

            const res = await axios.post('/api/Events/Clone/' + initialEvent.eventId, formData, headers);

            return res.data; //data has the cloned event object
        }
        catch(e) {
            alert(e.response.data.title);
            console.log(e)
        }
    }
)

const eventsSlice = createSlice({
    name: 'events',
    initialState,
    reducers: {
        //eventAdded(state, action) {
        //    state.push(action.payload)
        //},
        eventAdded: {
            reducer(state, action) {
                state.events.push(action.payload)
            },
            prepare(
                eventName,
                eventType,
                eventFormat,
                eventPlatform,
                eventEntry,
                eventUscfRated,
                eventFideRated,
                eventPlatformRated,
                eventPairingSystem,
                eventTimeControl,
                eventRounds,
                eventPrizeFund,
                eventServiceLevel,
                eventDescription,
                eventAddress,
                eventCity,
                eventState,
                eventZipCode,
                eventTimeZone,
                eventStartDateTime,
                eventEndDateTime,
                eventRegistrationDeadline,
                eventByeRequestDeadline,
                eventFlyerUrl,
                eventRegistrationUrl,
                eventPairingUrl,
                eventLiveGameUrl,
                eventHotelReservationLink,
                eventFideRegistrationLink
            ) {
                return {
                    payload: {
                        id: nanoid(),
                        eventName,
                        eventType,
                        eventFormat,
                        eventPlatform,
                        eventEntry,
                        eventUscfRated,
                        eventFideRated,
                        eventPlatformRated,
                        eventPairingSystem,
                        eventTimeControl,
                        eventRounds,
                        eventPrizeFund,
                        eventServiceLevel,
                        eventDescription,
                        eventAddress,
                        eventCity,
                        eventState,
                        eventZipCode,
                        eventTimeZone,
                        eventStartDateTime,
                        eventEndDateTime,
                        eventRegistrationDeadline,
                        eventByeRequestDeadline,
                        eventFlyerUrl,
                        eventRegistrationUrl,
                        eventPairingUrl,
                        eventLiveGameUrl,
                        eventHotelReservationLink,
                        eventFideRegistrationLink
                    }
                }
            }
        },
        eventUpdated: {
            reducer(state, action) {
                //state.events.push(action.payload)
                const { eventId,
                eventName,
                eventType,
                eventFormat,
                eventPlatform,
                eventEntry,
                eventUscfRated,
                eventFideRated,
                eventPlatformRated,
                eventPairingSystem,
                eventTimeControl,
                eventRounds,
                eventPrizeFund,
                eventServiceLevel,
                eventDescription,
                eventAddress,
                eventCity,
                eventState,
                eventZipCode,
                eventTimeZone,
                eventStartDateTime,
                eventEndDateTime,
                eventRegistrationDeadline,
                eventByeRequestDeadline,
                eventFlyerUrl,
                eventRegistrationUrl,
                eventPairingUrl,
                eventLiveGameUrl,
                eventHotelReservationLink,
                eventFideRegistrationLink } = action.payload
                const existingEvent = state.events.find(event => event.eventID === action.payload.eventId)
                if (existingEvent)  {
                        existingEvent.eventName = eventName
                        existingEvent.eventType = eventType
                        existingEvent.eventFormat = eventFormat
                        existingEvent.eventPlatform = eventPlatform
                        existingEvent.eventEntry = eventEntry
                        existingEvent.eventUscfRated = eventUscfRated
                        existingEvent.eventFideRated = eventFideRated
                        existingEvent.eventPlatformRated = eventPlatformRated
                        existingEvent.eventPairingSystem = eventPairingSystem
                        existingEvent.eventTimeControl = eventTimeControl
                        existingEvent.eventRounds = eventRounds
                        existingEvent.eventPrizeFund = eventPrizeFund
                        existingEvent.eventServiceLevel = eventServiceLevel
                        existingEvent.eventDescription = eventDescription
                        existingEvent.eventAddress = eventAddress
                        existingEvent.eventCity = eventCity
                        existingEvent.eventState = eventState
                        existingEvent.eventZipCode = eventZipCode
                        existingEvent.eventTimeZone = eventTimeZone
                        existingEvent.eventStartDateTime = eventStartDateTime
                        existingEvent.eventEndDateTime = eventEndDateTime
                        existingEvent.eventRegistrationDeadline = eventRegistrationDeadline
                        existingEvent.eventByeRequestDeadline = eventByeRequestDeadline
                        existingEvent.eventFlyerUrl = eventFlyerUrl
                        existingEvent.eventRegistrationUrl = eventRegistrationUrl
                        existingEvent.eventPairingUrl = eventPairingUrl
                        existingEvent.eventLiveGameUrl = eventLiveGameUrl
                        existingEvent.eventHotelReservationLink = eventHotelReservationLink
                        existingEvent.eventFideRegistrationLink = eventFideRegistrationLink
                }
            },
            prepare(
                eventId,
                eventName,
                eventType,
                eventFormat,
                eventPlatform,
                eventEntry,
                eventUscfRated,
                eventFideRated,
                eventPlatformRated,
                eventPairingSystem,
                eventTimeControl,
                eventRounds,
                eventPrizeFund,
                eventServiceLevel,
                eventDescription,
                eventAddress,
                eventCity,
                eventState,
                eventZipCode,
                eventTimeZone,
                eventStartDateTime,
                eventEndDateTime,
                eventRegistrationDeadline,
                eventByeRequestDeadline,
                eventFlyerUrl,
                eventRegistrationUrl,
                eventPairingUrl,
                eventLiveGameUrl,
                eventHotelReservationLink,
                eventFideRegistrationLink
            ) {
                return {
                    payload: {
                        eventId,
                        eventName,
                        eventType,
                        eventFormat,
                        eventPlatform,
                        eventEntry,
                        eventUscfRated,
                        eventFideRated,
                        eventPlatformRated,
                        eventPairingSystem,
                        eventTimeControl,
                        eventRounds,
                        eventPrizeFund,
                        eventServiceLevel,
                        eventDescription,
                        eventAddress,
                        eventCity,
                        eventState,
                        eventZipCode,
                        eventTimeZone,
                        eventStartDateTime,
                        eventEndDateTime,
                        eventRegistrationDeadline,
                        eventByeRequestDeadline,
                        eventFlyerUrl,
                        eventRegistrationUrl,
                        eventPairingUrl,
                        eventLiveGameUrl,
                        eventHotelReservationLink,
                        eventFideRegistrationLink
                    }
                }
            }
        },
        //eventUpdated(state, action) {
        //    const { eventId,
        //        eventName,
        //        eventType,
        //        eventFormat,
        //        eventPlatform,
        //        eventEntry,
        //        eventUscfRated,
        //        eventFideRated,
        //        eventPlatformRated,
        //        eventPairingSystem,
        //        eventTimeControl,
        //        eventRounds,
        //        eventPrizeFund,
        //        eventServiceLevel,
        //        eventDescription,
        //        eventAddress,
        //        eventCity,
        //        eventState,
        //        eventZipCode,
        //        eventTimeZone,
        //        eventStartDateTime,
        //        eventEndDateTime,
        //        eventRegistrationDeadline,
        //        eventByeRequestDeadline,
        //        eventFlyerUrl,
        //        eventRegistrationUrl,
        //        eventPairingUrl,
        //        eventLiveGameUrl,
        //        eventHotelReservationLink,
        //        eventFideRegistrationLink } = action.payload
        //    const existingEvent = state.events.find(event => event.eventId === eventId)
        //    if (existingEvent) {
        //            existingEvent.eventName = eventName,
        //            existingEvent.eventType = eventType,
        //            existingEvent.eventFormat = eventFormat,
        //            existingEvent.eventPlatform = eventPlatform,
        //            existingEvent.eventEntry = eventEntry,
        //            existingEvent.eventUscfRated = eventUscfRated,
        //            existingEvent.eventFideRated = eventFideRated,
        //            existingEvent.eventPlatformRated = eventPlatformRated,
        //            existingEvent.eventPairingSystem = eventPairingSystem,
        //            existingEvent.eventTimeControl = eventTimeControl,
        //            existingEvent.eventRounds = eventRounds,
        //            existingEvent.eventPrizeFund = eventPrizeFund,
        //            existingEvent.eventServiceLevel = eventServiceLevel,
        //            existingEvent.eventDescription = eventDescription,
        //            existingEvent.eventAddress = eventAddress,
        //            existingEvent.eventCity = eventCity,
        //            existingEvent.eventState = eventState,
        //            existingEvent.eventZipCode = eventZipCode,
        //            existingEvent.eventTimeZone = eventTimeZone,
        //            existingEvent.eventStartDateTime = eventStartDateTime,
        //            existingEvent.eventEndDateTime = eventEndDateTime,
        //            existingEvent.eventRegistrationDeadline = eventRegistrationDeadline,
        //            existingEvent.eventByeRequestDeadline = eventByeRequestDeadline,
        //            existingEvent.eventFlyerUrl = eventFlyerUrl,
        //            existingEvent.eventRegistrationUrl = eventRegistrationUrl,
        //            existingEvent.eventPairingUrl = eventPairingUrl,
        //            existingEvent.eventLiveGameUrl = eventLiveGameUrl,
        //            existingEvent.eventHotelReservationLink = eventHotelReservationLink,
        //            existingEvent.eventFideRegistrationLink = eventFideRegistrationLink
        //    }
        //}
    },
    extraReducers(builder) {
        builder
            .addCase(fetchEvents.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchEvents.fulfilled, (state, action) => {
                state.status = 'succeeded'
                // Add any fetched events to the array
                state.events = state.events.concat(action.payload)
            })
            .addCase(fetchEvents.rejected, (state, action) => {
                state.status = 'failed'
                state.error = action.error.message
            })
            .addCase(addNewEvent.fulfilled, (state, action) => {
                // We can directly add the new event object to our events array
                state.events.push(action.payload)
            })
            .addCase(updateEvent.fulfilled, (state, action) => {
                // We can directly add the new event object to our events array
                // state.events.push(action.payload)
                //update the event in the event list
                //try {
                //    const existingEvent1 = state.events.find(event => event.eventId === action.payload.eventId)
                //}
                //catch (err) {
                //    console.error('Failed to update the event: ', err)
                //}

                const existingEvent = state.events.find(event => event.eventID === action.payload.eventId)
                if (existingEvent) {
                    existingEvent.eventName = action.payload.eventName
                        existingEvent.eventType = action.payload.eventType
                        existingEvent.eventFormat = action.payload.eventFormat
                        existingEvent.eventPlatform = action.payload.eventPlatform
                        existingEvent.eventEntry = action.payload.eventEntry
                        existingEvent.eventUscfRated = action.payload.eventUscfRated
                        existingEvent.eventFideRated = action.payload.eventFideRated
                        existingEvent.eventPlatformRated = action.payload.eventPlatformRated
                        existingEvent.eventPairingSystem = action.payload.eventPairingSystem
                        existingEvent.eventTimeControl = action.payload.eventTimeControl
                        existingEvent.eventRounds = action.payload.eventRounds
                        existingEvent.eventPrizeFund = action.payload.eventPrizeFund
                        existingEvent.eventServiceLevel = action.payload.eventServiceLevel
                        existingEvent.eventDescription = action.payload.eventDescription
                        existingEvent.eventAddress = action.payload.eventAddress
                        existingEvent.eventCity = action.payload.eventCity
                        existingEvent.eventState = action.payload.eventState
                        existingEvent.eventZipCode = action.payload.eventZipCode
                        existingEvent.eventTimeZone = action.payload.eventTimeZone
                        existingEvent.eventStartDateTime = action.payload.eventStartDateTime
                        existingEvent.eventEndDateTime = action.payload.eventEndDateTime
                        existingEvent.eventRegistrationDeadline = action.payload.eventRegistrationDeadline
                        existingEvent.eventByeRequestDeadline = action.payload.eventByeRequestDeadline
                        existingEvent.eventFlyerUrl = action.payload.eventFlyerUrl
                        existingEvent.eventRegistrationUrl = action.payload.eventRegistrationUrl
                        existingEvent.eventPairingUrl = action.payload.eventPairingUrl
                        existingEvent.eventLiveGameUrl = action.payload.eventLiveGameUrl
                        existingEvent.eventHotelReservationLink = action.payload.eventHotelReservationLink
                        existingEvent.eventFideRegistrationLink = action.payload.eventFideRegistrationLink
                }
            })
            .addCase(deleteEvent.fulfilled, (state, action) => {
                let events = state.events.filter(event => event.eventID !== action.payload.eventId)
                state.events = events;
            })
    },
})

export const { eventAdded, eventUpdated, eventCloned, eventDeleted } = eventsSlice.actions
export default eventsSlice.reducer

export const selectAllEvents = state => state.events.events

export const selectEventById = (state, eventId) =>
    state.events.events.find(event => event.eventID === eventId)



//https://stackoverflow.com/questions/63128875/action-payload-in-creactasyncthunk-is-undefined
//export const fetchEvents = createAsyncThunk('events/fetchEvents', async () => {
//    const apiPath = '/api/Events';
//    //setToken(await authService.getAccessToken());
//    //var headers = {
//    //    headers: { 'Authorization': `Bearer ${token}` }
//    //}
//    //axios.get(apiPath, headers).then((response) => {
//    axios.get(apiPath).then((response) => {
//        let haha = response.data;
//        return response.data;
//    }).catch((error) => {
//        console.log(JSON.stringify(error));
//        return null;
//    });

//})


//export const fetchEvents = createAsyncThunk('events/fetchEvents', async () => {
//    const apiPath = '/api/Events';
//    //setToken(await authService.getAccessToken());
//    //var headers = {
//    //    headers: { 'Authorization': `Bearer ${token}` }
//    //}
//    //axios.get(apiPath, headers).then((response) => {
//    axios.get(apiPath).then((response) => {
//        let haha = response.data;
//        //return response.data;
//        return haha;
//    }).catch((error) => {
//        console.log(JSON.stringify(error));
//        return null;
//    });

//})